<!-- Point at local static wrappers (not chewzie.me directly) so the edge can allow framing it via a CSP scoped to just these paths, without touching the main app's policy. -->
<woa-modal-page-layout [customGeometry]="{pillarboxedOnDesktop: 'none'}">
    @if (display() == 'terms') {
        <iframe src="assets/bridges/legal-terms-frame.html" class="legal-content" sandbox></iframe>
    } @else if (display() == 'privacy') {
        <iframe src="assets/bridges/legal-privacy-policy-frame.html" class="legal-content" sandbox></iframe>
    }
</woa-modal-page-layout>
